/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_End_QuestionInputs */

const en_blog_end_question = /** @type {(inputs: Blog_End_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a process you'd like to talk through?`)
};

const lv_blog_end_question = /** @type {(inputs: Blog_End_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir process, ko gribētos pārrunāt?`)
};

/**
* | output |
* | --- |
* | "Have a process you'd like to talk through?" |
*
* @param {Blog_End_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_end_question = /** @type {((inputs?: Blog_End_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_End_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_end_question(inputs)
	return en_blog_end_question(inputs)
});